import React from 'react';
import AceLogo from '../../assets/img/logo/Logo_final_transparent.png';

const SingleSlide = () => {
  return (
    <section className="ace-hero">
      <div className="ace-hero-top-line" />

      <div className="ace-hero-content">

        <div className="ace-hero-logo-area">
          <img
            src={AceLogo}
            alt="ACE - Actions, Culture of Excellence"
            className="ace-hero-logo"
          />
        </div>

        <div className="ace-hero-main">

          <div className="ace-hero-words">

            <span className="ace-word ace-word-1">
              ACTIONS
            </span>

            <span className="ace-separator">
              |
            </span>

            <span className="ace-word ace-word-2">
              CULTURE
            </span>

            <span className="ace-separator">
              |
            </span>

            <span className="ace-word ace-word-3">
              EXCELLENCE
            </span>

          </div>

          <h2 className="ace-hero-title">
            Actions, Culture of Excellence
          </h2>

          <div className="ace-hero-title-line" />

          <div className="ace-hero-pillars">

            <div className="ace-hero-pillar">
              <span className="ace-hero-icon">
                ◉
              </span>

              <span>
                Empowering enterprises
              </span>
            </div>

            <div className="ace-hero-dot">
              •
            </div>

            <div className="ace-hero-pillar">
              <span className="ace-hero-icon">
                ◉
              </span>

              <span>
                Building skills
              </span>
            </div>

            <div className="ace-hero-dot">
              •
            </div>

            <div className="ace-hero-pillar">
              <span className="ace-hero-icon">
                ◉
              </span>

              <span>
                Expanding opportunities
              </span>
            </div>

          </div>

        </div>

      </div>

      <div className="ace-hero-bottom-line" />
    </section>
  );
};

export default SingleSlide;
